import { useAppSelector } from 'store';
import { useGetOpenRequestCountsQuery } from 'store/api/payerRequestApi';
import { useGetSegmentsQuery } from 'store/api/referenceApi';

/** Get open requests counts for all payers the user has access to */
export const useOpenRequestCounts = (skip?: boolean) => {
    const { segmentIds } = useAppSelector((state) => state.auth);

    const { data: segments } = useGetSegmentsQuery(undefined, { skip });

    // Infer the payer ids the user has access to based on their segments
    const payerIds = [
        ...new Set(
            segmentIds
                .map(
                    (segmentId) =>
                        segments?.find((segment) => segment.segmentId === segmentId)?.payerId,
                )
                .filter((payerId) => payerId) as string[],
        ),
    ];

    return useGetOpenRequestCountsQuery({ payerIds }, { skip: skip ?? payerIds.length === 0 });
};
